import { FC } from 'react';
import { useLocation } from 'react-router';

import useTranslations from 'modules/I18n/hooks/useTranslations';

import Box from '../Box';
import { getErrorMessageBaiCode } from './getErrorMessageBaiCode';
import messages from './messages';

type Props = {
  code: string;
  extraCode?: string | number;
  isPartial?: boolean;
};

const HasSpecificTaxAuthorityValidationsText: FC<Props> = ({
  code,
  extraCode,
  isPartial,
}) => {
  const { t } = useTranslations();
  const location = useLocation();
  const isBaiSubmission = location.pathname.includes('bai-submission');
  const errorMessage = getErrorMessageBaiCode(code, extraCode);
  if (!errorMessage) {
    return null;
  }
  const isDocumentPartial = isPartial
    ? t(messages.info)
    : t(messages.partialInfo);
  return (
    <>
      <Box tag="span" display="block" marginBottom="16px">
        {`[${code}]: ${t(errorMessage)}`}
      </Box>
      <Box tag="span" display="block">
        {isBaiSubmission ? t(messages.info) : isDocumentPartial}
      </Box>
    </>
  );
};

export default HasSpecificTaxAuthorityValidationsText;
